import React from 'react';

interface IVectorImage {
    svg: JSX.Element | JSX.Element[];
    hiddenText?: JSX.Element | JSX.Element[] | string;
    children?: JSX.Element | JSX.Element[] | string;
    classes?: string;
}

const VectorImage = ({
    svg,
    hiddenText,
    children,
    classes,
}: IVectorImage): React.ReactElement => (
    <i className={classes}>
        {svg}
        {hiddenText}
        {children}
    </i>
);

export default VectorImage;
